module.exports = __webpack_public_path__ + "img/9788950932862.25bfd284.jpg";